export class Zipcode {
  zipCode: number;
  city: string;
  stateId: string;
  stateName: string;
  countyFips: number;
  countyName: string;
  timezone: string;
  lat: number;
  lng: number;

  constructor(
    zipCode,
    city,
    stateId,
    stateName,
    countyFips,
    countyName,
    timezone,
    lat,
    lng
  ) {
    this.zipCode = zipCode;
    this.city = city;
    this.stateId = stateId;
    this.stateName = stateName;
    this.countyFips = countyFips;
    this.countyName = countyName;
    this.timezone = timezone;
    this.lat = lat;
    this.lng = lng;
  }
}
